import clsx from 'clsx'

import CheckIcon from 'shared/icons/tick_green_icon.svg'

import styles from './styles.module.scss'

interface Props {
  isChecked?: boolean
  title?: string
  error?: boolean
  onClick?: (value?: boolean) => void
  isBigSize?: boolean
  isDisabled?: boolean
}

export const CheckBoxSimple = ({
  error,
  isBigSize,
  isChecked = false,
  onClick,
  isDisabled = false,
}: Props) => {
  return (
    <div
      className={styles.container}
      onClick={() => {
        if (!isDisabled) {
          onClick?.(!isChecked)
        }
      }}
    >
      <div
        className={clsx(
          styles.box,
          error && styles.error,
          isBigSize && styles.big,
        )}
      >
        {isChecked ? (
          <img
            src={CheckIcon}
            alt=""
          />
        ) : (
          <div className={styles.unActive} />
        )}
      </div>
    </div>
  )
}
